module.exports = __webpack_public_path__ + "img/24.09864f71.jpg";